<template>
	<div v-if='options != null && selectable != null'>
		<input type='hidden' :name='name+"[]"' :value='v' v-for='v in options.value(selectable)' />
		<Error v-if='!hideError' :error='error' class='mt-0 mb-4' />

	    <div class='grid grid-cols-2 lg:grid-cols-3 gap-3'>
	        <label v-for='(option, oi) in selectable'
	            class='p-7 h-120 flex items-center justify-center cursor-pointer relative border'
	            :class='[ options.selected(option) ? "border-green-600 bg-green-600 bg-opacity-003" : "border-grey-500" ]'
	            @click='options.toggle(option)'
	        >
	            <img :src='"https://app.getwork.uk/storage"+option.image_display'
	            	class='max-h-full max-w-full' />
	        </label>
	    </div>
	</div>
</template>

<script>
	import input from '~/mixins/input.js'

	export default {
		props: {
			selectable: { default: null, type: Array },
			options: { default: null, type: Object }
		},

		mixins: [input]
	}
</script>